
//for live
 export const demoUrl="https://nicdsign.kerala.nic.in/demo/"
//for localhost
// export const demoUrl="https://sandboxkerala.nic.in/demo/"